import { styled } from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScLoyaltySection = styled.div`
  position: relative;
  display: grid;
  padding-top: 40px;
  margin-top: -32px;

  &::before {
    position: absolute;
    content: '';
    top: -64px;
    left: 0;
    width: 460px;
    height: 100%;
    opacity: 0.4;
    background: linear-gradient(90deg, #190f1f 0%, rgba(25, 15, 31, 0) 100%);
    mix-blend-mode: multiply;
    z-index: 1;
  }

  & .message {
    color: ${({ theme }) => theme.whiteColor};
  }

  & .head {
    display: grid;
    gap: 12px;
    padding-left: 68px;
    z-index: 2;
  }

  & .head .title {
    color: ${({ theme }) => theme.whiteColor};
    ${typography.headline1}
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  & .head .description {
    color: ${({ theme }) => theme.whiteColor};
    ${typography.body2regular}
    max-width: 465px;
  }

  & .slider-wrapper {
    position: relative;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-top: 50px;
    margin-bottom: 38px;
    z-index: 2;

    &.has-scroll-left::before {
      opacity: 1;
    }

    &.has-scroll-right::after {
      opacity: 1;
    }
  }

  & .info {
    margin-bottom: 38px;
  }

  & .info .cards {
    margin: 0;
    gap: 20px;
  }

  & .timer-section p {
    margin-bottom: 4px;
  }

  & .slider-wrapper .cards {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    overflow-x: auto;
    padding: 0 68px;
    scroll-behavior: smooth;
    -ms-overflow-style: none;
    scrollbar-width: none;
    scroll-snap-type: x mandatory;
    scroll-padding-inline-start: 68px;

    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }
  }

  & .arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    border-radius: 360px;
    background: ${({ theme }) => theme.whiteColor};
    border: none;
    cursor: pointer;
    z-index: 1;
    box-shadow:
      0 0 8px 0 rgba(0, 0, 0, 0.2),
      0 0 12px 0 rgba(0, 0, 0, 0.6);

    &.left {
      left: 16px;
      transform: translateY(-50%) rotate(180deg);
    }

    &.right {
      right: 16px;
    }
  }

  & .pagination {
    display: none;
    justify-content: center;
    gap: 8px;
    margin-top: 16px;
  }

  & .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: none;
    padding: 0;
    background: rgba(255, 255, 255, 0.3);
    cursor: pointer;
    transition: background 0.2s;

    &.active {
      background: ${({ theme }) => theme.whiteColor};
    }
  }

  & .page-cta {
    max-width: 280px;
    margin: 24px auto 0;
  }

  & .bg-wrapper {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100vw;
    max-height: 597px;
    height: 100%;
    z-index: -1;

    & img {
      object-fit: cover;
    }
  }

  & .animated-element-1 {
    position: absolute;
    top: -200px;
    left: -300px;
    z-index: -1;
  }

  & .animated-element-2 {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: -1;
  }

  @media (${device.mobile}) {
    &::before {
      width: 100%;
    }

    & .head {
      padding: 0 16px;
    }

    & .head .title {
      ${typography.headline2}
      text-align: center;
    }

    & .head .timer-section {
      margin: 0 auto;
      text-align: center;
    }

    & .head .description {
      text-align: center;
    }

    & .slider-wrapper {
      margin-top: 24px;
      margin-bottom: 64px;

      &::before,
      &::after {
        display: none;
      }
    }

    & .info {
      margin-bottom: 64px;
    }

    & .slider-wrapper .cards {
      padding: 0px calc((100vw - 308px) / 2);
      scroll-padding-inline-start: 0;
      align-items: flex-start;
    }

    & .cards {
      margin: 0;
      gap: 20px;
    }

    & .arrow {
      display: none;
    }

    & .timer-section {
      display: flex;
      align-items: center;
      gap: 4px;

      & p {
        font-size: 14px;
        line-height: 14px;
        letter-spacing: 0;
        text-align: left;
        margin: 0;
      }
    }

    & .pagination {
      display: flex;
    }

    & .animated-element-1 {
      top: -125px;
      left: -525px;
    }

    & .animated-element-2 {
      display: none;
    }
  }
`;

export const ScCard = styled.div`
  position: relative;
  border-radius: 24px;
  backdrop-filter: blur(2px);
  background: linear-gradient(180deg, rgba(28, 28, 30, 0.8) 0%, #1c1c1e 100%);
  backdrop-filter: blur(2px);
  padding: 2px;
  scroll-snap-align: left;
  flex-shrink: 0;
  max-width: 344px;
  width: 100%;

  & > .inner {
    position: relative;
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
    border-radius: 24px;
    z-index: 10;
  }

  & .header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    height: 26px;
  }

  & .title {
    color: ${({ theme }) => theme.whiteColor};
    ${typography.body1bold};
    white-space: nowrap;

    &:only-child {
      margin: 0 auto;
    }
  }

  & .image-container {
    position: relative;

    & img {
      position: relative;
      z-index: 2;
    }
  }

  & .blur {
    position: absolute;
    width: 117px;
    height: 117px;
    background-color: #00b7ff;
    opacity: 0.5;
    filter: blur(32px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }

  & .perks {
    display: flex;
    min-height: 264px;
    padding: 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.02);
  }

  & .perk-container {
    width: 100%;
  }

  & .perk {
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
  }

  & .perk-activated {
    text-transform: capitalize;
    color: ${({ theme }) => theme.greenSuccessColor};
    font-weight: 400;
  }

  & .perk-title {
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${({ theme }) => theme.whiteColor};
    ${typography.caption1bold};
    width: 100%;
  }

  & .activated-badge {
    margin-left: auto;
  }

  & .perk-description {
    color: #8e8e93;
    ${typography.caption1regular}
  }

  & .perk.unavailable .perk-title,
  & .perk.unavailable .perk-description,
  & .perk.unavailable .icon-lock {
    color: #8e8e93;
  }

  & .locked-indicator,
  & .completed-indicator {
    display: flex;
    height: 40px;
    padding: 0 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 360px;
    background: rgba(255, 255, 255, 0.2);
    color: ${({ theme }) => theme.whiteColor};
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    line-height: 16px;
    text-transform: uppercase;
  }

  & .checkmark {
    position: absolute;
    display: flex;
    width: 39px;
    height: 39px;
    justify-content: center;
    align-items: center;
    border-radius: 360px;
    background: ${({ theme }) => theme.greenSuccessColor};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
  }

  &.unregistered,
  &.locked {
    & img {
      filter: grayscale(100%);
    }

    & .perk .icon-tickIcon,
    & .perk .icon-present {
      color: #8e8e93;
    }
  }

  &.in_progress {
    &::after {
      content: '';
      position: absolute;
      display: block;
      padding: 2px;
      background: linear-gradient(rgb(255, 216, 0) 0%, rgb(29, 29, 32) 100%);
      border-radius: 24px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: calc(100% - 4px);
      -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
    }

    & .title {
      background: linear-gradient(90deg, #ffad01 0.03%, #ffd500 99.97%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    & .perk .icon-tickIcon,
    & .perk .icon-present {
      color: ${({ theme }) => theme.greenSuccessColor};
    }
  }

  &.completed {
    & .perk .icon-tickIcon,
    & .perk .icon-present {
      color: ${({ theme }) => theme.blackLightColor};
    }
  }

  &.bronze {
    &::after {
      background: linear-gradient(#a47350 0%, #1d1d20 100%);
    }
  }

  &.silver {
    &::after {
      background: linear-gradient(#c1c2c2 0%, #1d1d20 100%);
    }
  }

  &.gold {
    &::after {
      background: linear-gradient(#ffd800 0%, #1d1d20 100%);
    }
  }

  &.emerald {
    &::after {
      background: linear-gradient(#2ad59c 0%, #1d1d20 100%);
    }
  }

  &.diamond {
    &::after {
      background: linear-gradient(#23dcff 0%, #1d1d20 100%);
    }
  }

  @media (${device.mobile}) {
    scroll-snap-align: center;
    max-width: 308px;
  }

  @media (max-width: 360px) {
    scroll-snap-align: center;
    max-width: 288px;
  }
`;

export const ScStepsCard = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  padding: 24px 64px 24px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  flex: 1 0 0;
  border-radius: 12px;
  background: #1c1c1e;

  & .title {
    color: ${({ theme }) => theme.whiteColor};
    ${typography.body1bold}
  }

  & .description {
    color: rgba(255, 255, 255, 0.6);
    ${typography.body1regular}
  }

  & .image {
    position: absolute;
    top: 13px;
    right: 10px;
  }

  @media (${device.mobile}) {
    min-height: none;
  }
`;

export const ScProgressBarContainer = styled.div`
  width: 100%;

  & .progress-wrapper {
    position: relative;
  }

  & .retain-marker {
    position: absolute;
    top: calc(100% - 2px);
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 8px solid #ffd800;
    z-index: 1;
  }

  &.secured {
    & .retain-marker {
      border-bottom: 8px solid #1ab232;
    }

    & .bottom .text {
      color: ${({ theme }) => theme.greenSuccessColor};
    }
  }

  & .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    margin-top: 6px;
    min-height: 14px;

    & .text {
      position: relative;
      display: flex;
      align-items: center;
      gap: 4px;
      color: rgba(255, 255, 255, 0.6);
      text-align: center;
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      ${typography.caption2regular}
    }

    & .right-aligned {
      margin-left: auto;
      cursor: default;
    }

    & .tooltip {
      top: 24px;
      left: 0;
      position: absolute;
      display: flex;
      width: 312px;
      padding: 12px;
      justify-content: center;
      align-items: center;
      border-radius: 12px;
      background: ${({ theme }) => theme.whiteColor};
      box-shadow:
        0 0 8px 0 rgba(0, 0, 0, 0.2),
        0 0 12px 0 rgba(0, 0, 0, 0.6);

      color: #000;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0;
    }
  }
`;
